import { Variables } from "./Variables";
import triggerIcon from "../../../../new-images/profile/trigger-icon.svg";
import triggerIconSuccess from "../../../../new-images/profile/trigger-icon-success.svg";
import successImg from "../../../../new-images/profile/success.svg";
import ErrorMessage from "../../../errorMessage";
import Input from "../../ui/input/Input";

export const useCountDonationsVariables = (errors, value, setValue) => {

  return new Variables(
    {
      title: "Сколько у вас было донаций",
      bold: " на момент регистрации ",
      afterTitle: "в DonorSearch?",
      img: triggerIcon,
      prompt:
        "Мы проводим исследование влияния DonorSearch на донорство. Укажите, пожалуйста, сколько у вас было донаций на момент регистрации в DonorSearch.",
      promptList: [
        "В случае, если вы не помните точное число, укажите приблизительно.",
        `Если на момент регистрации вы еще не были донором, поставьте&nbsp;“0”.`,
      ],
      button: "Сохранить",
      errorMessage: (
        <div>
          <ErrorMessage text={errors} />
        </div>
      ),
      htmlElement: (
        <Input
          placeholder={"Укажите число"}
          value={value.label}
          onChange={(e) =>
            setValue({ value: e.target.value, label: e.target.value })
          }
        />
      ),
    },
    {
      title: "Сколько у вас было донаций",
      bold: " на момент регистрации ",
      afterTitle: "в DonorSearch?",
      img: triggerIconSuccess,
      message: "Сохранено",
      succesImg: successImg,
      htmlElement: (
        <Input
          placeholder={"Укажите число"}
          defaultValue={value.label}
          disabled={true}
        />
      ),
    }
  )
};
